<template>

	<div>
		<el-dialog title="选择开具信息"  :visible.sync="Anewtk" :close-on-click-modal="false" width="700px" v-dialogDrag>
					<div class="LeftAndRightLayout">
						<div>
							发票种类：<el-select style="width: 200px;" clearable v-model="fpzl" placeholder="请选择">
								<el-option v-for="item in fpzloptions" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</div>
						<div>
							发票类型：<el-select style="width: 200px;"clearable v-model="fplx" placeholder="请选择">
								<el-option v-for="item in fplxoptions" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="LeftAndRightLayout">
						<div>
							特殊业务：<el-select :disabled ="isjytdyw" clearable style="width: 200px;" v-model="cxtdywxz" placeholder="请选择(非必选项)">
								<el-option v-for="item in tdywoptions" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</div>
						<div>
							差额征税：<el-select :disabled ="isjycezs" clearable style="width: 200px;" v-model="cxcezsxz" placeholder="请选择(非必选项)">
								<el-option v-for="item in cezsoptions" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="LeftAndRightLayout">
						<div>
							减按征税：<el-select :disabled ="isjyjazs" clearable style="width: 200px;" v-model="cxjazsxz" placeholder="请选择(非必选项)">
								<el-option v-for="item in jazsoptions" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div style="justify-content: right; display:flex; ">
						<div class="addstyle" style="width: 88px;margin-right: 24px;" @click="reelecttype">保存</div>
						<div class="backstyle" style="width: 88px;margin-right: 24px;" @click="Anewtk=farlse">返回</div>
					</div>
					<div style="height: 30px;"></div>
			</el-dialog>
		<Billingcomponent :outerVisible="outerVisible" @closeouterVisible="closeouterVisible"
			@InvoiceBackInformation="InvoiceBackInformation" :title="title" @shenhechoose="shenhechoose"
			:ruleFormb="allitem.ruleFormb" :priceall="allitem.priceall" :totalall="allitem.totalall"
			:ruleFormbxiao="allitem.ruleFormbxiao" :form_chae="allitem.form_chae" :bztext="allitem.bztext"
			:stateall="allitem.stateall" :listoflists="allitem.listoflists" :invoiceNo="allitem.invoiceNo"
			:iszhengshu="true" :invoiceCode="allitem.invoiceCode" :billingDate="allitem.billingDate"
			:checkCode="allitem.checkCode" :buttonqx="buttonqx" :kaipiaotype=1></Billingcomponent>
		<!-- 开具弹框 -->
		<kgdiag @closekgdialog="closekgdialog" @radiochange="radiochange" @openInvoice="openInvoice"
			:headtitle="kgtitle" :kgdialog="kgdialog" :tableDatans="tableDatans" :tableDatakp="tableDatakp"></kgdiag>

    <!-- 修改自定义说明二修改 -->
    <el-dialog title="修改自定义说明二" :visible.sync="dialogApproval" width="100px;" v-dialogDrag>
      <taxform :Formlist="formlist" ref="taxForm" :formdata="formdata" ></taxform>
      <div  style="justify-content: center;margin-top: 40px; display: flex;">
		  <div class="backstyle" style="margin-right: 30px;margin-left: 30px; margin-bottom: 20px;" @click="dialogApproval = false">返回</div>
		  <div class="addstyle" style="margin-bottom: 20px;" @click="submitFrom">提交</div>
        <!-- <el-button @click="dialogApproval = false"  style="margin-right: 30px;margin-left: 30px;">返回</el-button>
        <el-button  @click="submitFrom" type="primary" plain>提交</el-button> -->
      </div>
    </el-dialog>
		<!-- 修改历史 -->
		<el-dialog :visible.sync="historyDialog" width="50%" :close-on-click-modal="false" append-to-body v-dialogDrag
			:before-close="closeAndQuery">
			<div>
				<el-form :model="historyConditionForm" label-width="80px" style="padding: 5px;">
					<div class="form-item">
						<el-form-item label="操作人" prop="xiugr">
							<el-input v-model="historyConditionForm.xiugr"></el-input>
						</el-form-item>
						<el-form-item label="修改类型" prop="bianglx">
							<el-select style="width: 120px;margin-left: 30px;" v-model="historyConditionForm.bianglx">
								<el-option v-for="item in bianglxs" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div class="buttonAll end-flex">
						 <div class="addstyle" style="width: 100px;margin: 10px;" @click="queryHistory">查询</div>
						  <div class="addstyle" style="width: 100px ;margin: 10px;" @click="resetHistoryQueryForm">重置</div>
						<!-- <el-button type="primary" style="width: 100px" plain @click="queryHistory">查询</el-button>
						<el-button type="primary" style="width: 100px" plain @click="resetHistoryQueryForm">重置 -->
<!--						</el-button>-->
					</div>
				</el-form>
				<div class="areacontent">
					<div style="margin:10px 20px;padding-bottom: 20px">
						<template>
							<el-table :data="historyData" border style="width: 100%" ref="multipleTable"
								:height="tableHeight">
								<el-table-column prop="createTime" label="修改时间">
									<template slot-scope="scope">
										{{ timestampToStr(scope.row.createTime, "yyyy年MM月dd日hh时mm分ss秒") }}
									</template>
								</el-table-column>
								<el-table-column prop="xiugr" label="操作人"></el-table-column>
								<el-table-column prop="bianglx" label="修改类型">
									<template slot-scope="scope">
										<p v-if="scope.row.bianglx == '0'">修改</p>
										<p v-if="scope.row.bianglx == '1'">拆分</p>
										<p v-if="scope.row.bianglx == '2'">合并</p>
										<p v-if="scope.row.bianglx == '3'">分组</p>
										<p v-if="scope.row.bianglx == '4'">开票</p>
										<p v-if="scope.row.bianglx == '5'">回滚</p>
									</template>
								</el-table-column>
								<el-table-column label="操作列">
									<template slot-scope="scope">
										<el-button type="text" v-if="scope.row.enabled"
											@click="rollbackOperation(scope.row)">撤销操作
										</el-button>
										<el-button type="text" v-else disabled>已撤销</el-button>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</div>
				</div>
			</div>
		</el-dialog>
    	<taxSearch :searchdata="searchalllist" :searchlist="searchlist" labelwidth="150px" labelPosition="left" @submitSearch="forshuai"></taxSearch>
		<div class="headline"></div>
		<div class="areacontent">
			<el-tabs v-model="choosetitleindex" @tab-click="clickchoosetap">
				<el-tab-pane label="电子普票填开" name="026"
					v-if="notemptyandnull(buttomroute.Fillinandissuepositiveinvoice_DP_select)"></el-tab-pane>
				<el-tab-pane label="电子专票填开" name="028"
					v-if="notemptyandnull(buttomroute.Fillinandissuepositiveinvoice_DZ_select)"></el-tab-pane>
				<el-tab-pane label="纸质普票填开" name="007"
					v-if="notemptyandnull(buttomroute.Fillinandissuepositiveinvoice_ZP_select)"></el-tab-pane>
				<el-tab-pane label="纸质专票填开" name="004"
					v-if="notemptyandnull(buttomroute.Fillinandissuepositiveinvoice_ZZ_select)"></el-tab-pane>
			</el-tabs>
			<div class="between-line">
				<div class="Centerupdown">
					<!-- <el-button type="primary" plain @click="Manualinput"
						v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_select_add||buttonqx.Fillinandissuepositiveinvoice_DZ_select_add||buttonqx.Fillinandissuepositiveinvoice_ZP_select_add||buttonqx.Fillinandissuepositiveinvoice_ZZ_select_add)">
						单据录入
						<i class="el-icon-circle-plus-outline el-icon--right"></i>
					</el-button> -->
					  	<div class="addstyle" style="width: 100px;" v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_select_add||buttonqx.Fillinandissuepositiveinvoice_DZ_select_add||buttonqx.Fillinandissuepositiveinvoice_ZP_select_add||buttonqx.Fillinandissuepositiveinvoice_ZZ_select_add)" @click="Manualinput" ><samp>单据录入
						<i class="el-icon-circle-plus-outline el-icon--right"></i></samp></div>
					<el-dropdown class="avatar-container" trigger="click" style="margin:0 10px">
						<div class="avatar-wrapper">
							<div class="addstyle" style="width: 100px;" ><samp>	拆分合并
								<i class="el-icon-caret-bottom" /></samp></div>
							<!-- <el-button type="primary" plain>
								拆分合并
								<i class="el-icon-caret-bottom" />
							</el-button> -->
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="mergeSameCustomer">合并相同客户</el-dropdown-item>
							<el-dropdown-item @click.native="detailSplit">手工拆分</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<!-- <el-button type="primary" plain>
               拆分合并
               <i class="el-icon-picture-outline el-icon--right"></i>
           </el-button> -->
					<!-- <el-button type="primary" @click="audit" plain
						v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_examine||buttonqx.Fillinandissuepositiveinvoice_DZ_examine||buttonqx.Fillinandissuepositiveinvoice_ZP_examine||buttonqx.Fillinandissuepositiveinvoice_ZZ_examine)">
						审核
						<i class="el-icon-timer el-icon--right"></i>
					</el-button> -->
					<div class="addstyle"@click="audit" plain
						v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_examine||buttonqx.Fillinandissuepositiveinvoice_DZ_examine||buttonqx.Fillinandissuepositiveinvoice_ZP_examine||buttonqx.Fillinandissuepositiveinvoice_ZZ_examine)" style="width: 70px;margin-right: 10px;" ><samp>审核
						<i class="el-icon-timer el-icon--right"></i></samp></div>

					<!-- <el-button type="primary" @click="cancelAudit" plain
						v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_cancel_examine||buttonqx.Fillinandissuepositiveinvoice_DZ_cancel_examine||buttonqx.Fillinandissuepositiveinvoice_ZP_cancel_examine||buttonqx.Fillinandissuepositiveinvoice_ZZ_cancel_examine)">
						取消审核
						<i class="el-icon-timer el-icon--right"></i>
					</el-button> -->
					<div class="addstyle"@click="cancelAudit" plain
						v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_cancel_examine||buttonqx.Fillinandissuepositiveinvoice_DZ_cancel_examine||buttonqx.Fillinandissuepositiveinvoice_ZP_cancel_examine||buttonqx.Fillinandissuepositiveinvoice_ZZ_cancel_examine)" style="width: 100px;margin-right: 10px;" ><samp>取消审核
						<i class="el-icon-timer el-icon--right"></i></samp></div>

					<!-- <el-button type="primary" @click="forkaiju('normal',false)" plain
						v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_Issue||buttonqx.Fillinandissuepositiveinvoice_DZ_Issue||buttonqx.Fillinandissuepositiveinvoice_ZP_Issue||buttonqx.Fillinandissuepositiveinvoice_ZZ_Issue)">
						开具
						<i class="el-icon-upload el-icon--right"></i>
					</el-button> -->
					<div class="addstyle"@click="forkaiju('normal',false)" plain
						v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_Issue||buttonqx.Fillinandissuepositiveinvoice_DZ_Issue||buttonqx.Fillinandissuepositiveinvoice_ZP_Issue||buttonqx.Fillinandissuepositiveinvoice_ZZ_Issue)" style="width: 70px;margin-right: 10px;" ><samp>开具<i class="el-icon-upload el-icon--right"></i></samp></div>


					<!--
					<el-button type="primary" @click="forkaiju('normal',true)" plain
						v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_IssueAndPrinting||buttonqx.Fillinandissuepositiveinvoice_DZ_IssueAndPrinting||buttonqx.Fillinandissuepositiveinvoice_ZP_IssueAndPrinting||buttonqx.Fillinandissuepositiveinvoice_ZZ_IssueAndPrinting)">
						开具并打印
						<i class="el-icon-upload el-icon--right"></i>
					</el-button> -->

					<div class="addstyle" @click="forkaiju('normal',true)" plain
						v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_IssueAndPrinting||buttonqx.Fillinandissuepositiveinvoice_DZ_IssueAndPrinting||buttonqx.Fillinandissuepositiveinvoice_ZP_IssueAndPrinting||buttonqx.Fillinandissuepositiveinvoice_ZZ_IssueAndPrinting)" style="width: 120px;margin-right: 10px;" ><samp>开具并打印
						<i class="el-icon-upload el-icon--right"></i></samp></div>
                   <!-- <el-button type="primary" @click="setingCheckPending" plain
                               v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_examine||buttonqx.Fillinandissuepositiveinvoice_DZ_examine||buttonqx.Fillinandissuepositiveinvoice_ZP_examine||buttonqx.Fillinandissuepositiveinvoice_ZZ_examine)">
                        置为待审核
                        <i class="el-icon-s-tools"></i>
                    </el-button> -->
					<div class="addstyle"@click="setingCheckPending" plain
                               v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_examine||buttonqx.Fillinandissuepositiveinvoice_DZ_examine||buttonqx.Fillinandissuepositiveinvoice_ZP_examine||buttonqx.Fillinandissuepositiveinvoice_ZZ_examine)"style="width: 120px;margin-right: 10px;" ><samp> 置为待审核
                        <i class="el-icon-s-tools"></i></samp></div>
					<div class="addstyle" style="width: 110px;margin-right: 10px;" @click="Anew()">重选发票类型
					</div>

					<!--<el-button type="primary" @click="auitAndKaiju" plain>
              审核并开具
              <i class="el-icon-timer el-icon&#45;&#45;right"></i>
          </el-button>-->
					<!-- <el-button type="danger" plain @click="Docdelete()"
						v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_delete||buttonqx.Fillinandissuepositiveinvoice_DZ_delete||buttonqx.Fillinandissuepositiveinvoice_ZP_delete||buttonqx.Fillinandissuepositiveinvoice_ZZ_delete)">
						删除
						<i class="el-icon-delete el-icon--right"></i>
					</el-button> -->
					<div class="dangestyle"@click="Docdelete()"
						v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_delete||buttonqx.Fillinandissuepositiveinvoice_DZ_delete||buttonqx.Fillinandissuepositiveinvoice_ZP_delete||buttonqx.Fillinandissuepositiveinvoice_ZZ_delete)"style="width: 70px;margin-right: 10px;" ><samp> 	删除
						<i class="el-icon-delete el-icon--right"></i></samp></div>



					<div class="Centerupdown">
						<div style="margin-left: 30px;font-size: 14px;margin-right: 5px;overflow: hidden;">自动审核</div>
						<el-tooltip class="item" effect="dark" content="开启自动审核后，新增的待审核信息将自动变为已审核状态"
							placement="top-start"
							v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_auto_examine||buttonqx.Fillinandissuepositiveinvoice_DZ_auto_examine||buttonqx.Fillinandissuepositiveinvoice_ZP_auto_examine||buttonqx.Fillinandissuepositiveinvoice_ZZ_auto_examine)">
							<el-switch plain v-model="isAudit" @change="updateIsAudit"></el-switch>
						</el-tooltip>
					</div>
          <div class="Centerupdown">
			  <div class="addstyle" style="margin-left: 30px; width: 130px;"  @click="openUpdateZidysm2()" >修改自定义说明二</div>
          <!--  <el-button style="margin-left: 30px;" type="primary" plain @click="openUpdateZidysm2()">
              修改自定义说明二
            </el-button> -->
          </div>
					<!--  <el-button type="primary" plain>
                合并相同客户
                <i class="el-icon-arrow-right el-icon--right"></i>
            </el-button> -->
				</div>
				<div class="Centerupdown">
				<!-- 	<el-input style="width: 280px;margin-right: 16px;" clearable
						placeholder="单据号、单据金额、发票号码、发票代码" prefix-icon="el-icon-search" @input="forserchlist"
						v-model="listlikeSearch"></el-input> -->
					<!--   <el-dropdown :hide-on-click="false">
             <span class="el-dropdown-link">
             <div class="aftericon" style="margin-right: 16px;"><img src="../../../assets/img/iconshai.png"/></div>
             </span>
                   <el-dropdown-menu slot="dropdown">
                       <el-checkbox-group v-model="checkmeauList">
                           <el-dropdown-item v-for="item in meaulist" :key="item">
                               <el-checkbox :label="item" :key="item">{{item}}</el-checkbox>
                           </el-dropdown-item>
                       </el-checkbox-group>

                   </el-dropdown-menu>
               </el-dropdown> -->
				</div>
			</div>
			<div class="areatable">
				<div class="tableh">
					<template>
						<el-table :data="tableData" ref="multipleTable" border style="width: 100%" height="calc(100vh - 395px )"
							@selection-change="handleSelectionChange" @row-click="selectClick" @sort-change="tableSortChange">
							<el-table-column type="selection" width="N5" fixed="left" align="center" key="1">
							</el-table-column>
							<el-table-column prop="stateall.docNo" align="left" min-width="160px" show-overflow-tooltip label="单据号" key="2"></el-table-column>
<!--							<el-table-column prop="documentStatus" label="单据状态" width="100" key="3">-->
<!--								<template slot-scope="scope">-->
<!--									&lt;!&ndash; 发票状态 -1:草稿 0：入库保存；1：已审核；2：待开票；3：开票中；4：已开票；7：开票失败；8：暂不开票；9：已退票；34：无需开票 &ndash;&gt;-->
<!--									<p v-if="scope.row.documentStatus == '-1'" style="color:#BEBEBE">草稿</p>-->
<!--									<p v-if="scope.row.documentStatus == '0'">待审核</p>-->
<!--									<p v-if="scope.row.documentStatus == '1'" style="color:#00DC16">已审核</p>-->
<!--									<p v-if="scope.row.documentStatus == '2'" style="color:#EE0101">待开票</p>-->
<!--									<p v-if="scope.row.documentStatus == '3'" style="color:#2F66FC">开票中</p>-->
<!--									<p v-if="scope.row.documentStatus == '4'" style="color:#FF8000">已开票</p>-->
<!--									<p v-if="scope.row.documentStatus == '5'" style="color:#FF8000">已作废</p>-->
<!--									<p v-if="scope.row.documentStatus == '6'" style="color:#FF8000">已红冲</p>-->
<!--									<p v-if="scope.row.documentStatus == '7'" style="color:#BEBEBE">开票失败</p>-->
<!--									<p v-if="scope.row.documentStatus == '8'" style="color:#00DC16">暂不开票</p>-->
<!--									<p v-if="scope.row.documentStatus == '9'" style="color:#00DC16">已退票</p>-->
<!--									<p v-if="scope.row.documentStatus == '10'" style="color:#00DC16">已合并</p>-->
<!--									<p v-if="scope.row.documentStatus == '21'" style="color:#00DC16">作废关闭中</p>-->
<!--									<p v-if="scope.row.documentStatus == '22'" style="color:#00DC16">作废重开中</p>-->
<!--									<p v-if="scope.row.documentStatus == '23'" style="color:#00DC16">作废锁定</p>-->
<!--									<p v-if="scope.row.documentStatus == '31'" style="color:#00DC16">未开发票冲销</p>-->
<!--									<p v-if="scope.row.documentStatus == '32'" style="color:#00DC16">已开发票冲销</p>-->
<!--									<p v-if="scope.row.documentStatus == '33'" style="color:#00DC16">作废冲销</p>-->
<!--									<p v-if="scope.row.documentStatus == '34'" style="color:#00DC16">无需开票</p>-->
<!--									<p v-if="scope.row.documentStatus == '35'" style="color:#00DC16">待作废</p>-->
<!--								</template>-->


<!--							</el-table-column>-->
              <el-table-column prop="documentStatus" sortable="custom" label="单据状态" align="center" min-width="100px"  key="3">
                <template slot-scope="scope">
                  <!-- 发票状态 -1:草稿 0：入库保存；1：已审核；2：待开票；3：开票中；4：已开票；7：开票失败；8：暂不开票；9：已退票；34：无需开票 -->
                  <p v-for="item in fapztlist" v-if="item.value==scope.row.documentStatus" :style="item.style">
                    <span>{{item.label}}</span>
                    <el-tooltip class="item" effect="light" :content="scope.row.stateall.shibxx"  v-if="scope.row.documentStatus == '7'"
                                placement="bottom">
                      <img src="../../../assets/img/erroricon.svg" style="margin-left: 5px;"  />
                    </el-tooltip>
                  </p>
                </template>
              </el-table-column>

							<el-table-column prop="faply" label="发票来源" sortable="custom"  min-width="110px" align="center" key="4">
								<template slot-scope="scope">
									<!-- 发票来源 发票来源 1：文件导入；2：手工录入；3：客户接口 4:税控同步5:支付开票6:扫码开票 -->
									<p v-if="scope.row.stateall.faply == '1'">文件导入</p>
									<p v-if="scope.row.stateall.faply == '2'">手工录入</p>
									<p v-if="scope.row.stateall.faply == '3'">客户接口</p>
									<p v-if="scope.row.stateall.faply == '4'">税控同步</p>
									<p v-if="scope.row.stateall.faply == '5'">支付开票</p>
									<p v-if="scope.row.stateall.faply == '6'">扫码开票</p>
									<p v-if="scope.row.stateall.faply == '7'">红冲重开</p>
                  <p v-if="scope.row.stateall.faply == '8'">作废重开</p>
								</template>
							</el-table-column>
							<el-table-column label="发票类型" min-width="110px" align="center" key="5">
								<template slot-scope="scope">
									<p v-if="scope.row.stateall.choosetitleindex == '026'">电子普票</p>
									<p v-if="scope.row.stateall.choosetitleindex == '028'">电子专票</p>
									<p v-if="scope.row.stateall.choosetitleindex == '007'">纸质普票</p>
									<p v-if="scope.row.stateall.choosetitleindex == '004'">纸质专票</p>
								</template>
							</el-table-column>
							<el-table-column prop="ruleFormb.customerName" label="购方名称" align="left" min-width="160px" show-overflow-tooltip
								key="5"></el-table-column>
							<el-table-column prop="totalall.pricetotal" label="金额" align="right" min-width="100" key="6">
								<template slot-scope="scope">
									<span>{{ toThousands(Amountformat(scope.row.totalall.pricetotal)) }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="totalall.taxtotal" label="税额" align="right" min-width="100" key="7">
								<template slot-scope="scope">
									<span>{{ toThousands(Amountformat(scope.row.totalall.taxtotal)) }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="priceall[0].goodsName" align="left" min-width="160px" show-overflow-tooltip label="商品名称" key="8"></el-table-column>
							<el-table-column prop="totalall.jiastotal" label="价税合计" align="right" min-width="100" key="9">
								<template slot-scope="scope">
									<span>{{ toThousands(Amountformat(scope.row.totalall.jiastotal)) }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="stateall.isqingdan" min-width="100" key="10" label="是否清单" align="center"
								v-if="choosetitleindex == '004'||choosetitleindex == '007'">
								<template slot-scope="scope">
									<span v-if="scope.row.stateall.isqingdan">是</span>
									<span v-else>否</span>
								</template>
							</el-table-column>

							<el-table-column prop="stateall.docDate" sortable="custom" align="left" min-width="160px" show-overflow-tooltip label="单据日期"  key="11">
								<template slot-scope="scope">
									<span>{{ yyyyMMdd(scope.row.stateall.docDate) }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="stateall.zhidr" sortable="custom" label="制单人" min-width="100" align="center" key="12">
							</el-table-column>
              <el-table-column prop="shenqr" label="申请人" min-width="100" align="center" key="13">
              </el-table-column>
              <el-table-column prop="zidysm" label="自定义说明" align="left" min-width="160px" show-overflow-tooltip key="14">
              </el-table-column>
              <el-table-column prop="zidysm2" label="自定义说明二" align="left" min-width="160px" show-overflow-tooltip key="15">
              </el-table-column>
              <el-table-column prop="stateall.kaipzddm" label="税盘编号" align="left" min-width="160px" show-overflow-tooltip key="16" >
              </el-table-column>
							<el-table-column prop="stateall.createTime" sortable="custom" label="创建日期" align="left" min-width="160px" show-overflow-tooltip key="17">
							</el-table-column>
							<!--							<el-table-column prop="historyChangeCount" label="次数" width="200" align="center"></el-table-column>-->
							<el-table-column fixed="right" label="操作列" min-width="200" key="18" align="center">
								<template slot-scope="scope">
									<el-button @click="handleClick(scope.row, '预览发票')" type="text" size="small">预览
									</el-button>
									<el-button @click="handleEdit(scope.row, '编辑发票')" type="text" size="small"
										:disabled="scope.row.documentStatus !== '-1' && scope.row.documentStatus !== '0' && scope.row.documentStatus !== '7' && scope.row.documentStatus !== '4' && scope.row.documentStatus !== '6'">
										编辑
									</el-button>
									<el-button :disabled="scope.row.documentStatus != '1' && scope.row.documentStatus != '7'"
										@click.stop="openInvoiceSingle(scope.row,'',scope.row.id)" type="text" size="small"
										v-if="notemptyandnull(buttonqx.Fillinandissuepositiveinvoice_DP_Issue||buttonqx.Fillinandissuepositiveinvoice_DZ_Issue||buttonqx.Fillinandissuepositiveinvoice_ZP_Issue||buttonqx.Fillinandissuepositiveinvoice_ZZ_Issue)">
										开具
									</el-button>
									<el-button @click="showHistory(scope.row)" type="text" size="small"
										:disabled="scope.row.historyChangeCount == 0">历史
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="lastend">
					<div>
						当前已勾选
						<span>{{ selectCount }}</span>
						条
					</div>
					<div>
						合计金额
						<span>￥{{ toThousands(Amountformat(jiastotalSum)) }}</span>
					</div>
					<div>
						合计税额
						<span>￥{{ toThousands(Amountformat(taxtotalSum)) }}</span>
					</div>
				</div>
				<div class="buttompage">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]" :key="elementui_page_component_key" :current-page.sync="currentpage"
						:page-size="pagenum" layout="total, sizes, prev, pager, next, jumper" :total="totalcount">
					</el-pagination>
				</div>
			</div>
		</div>

        <manualSplit v-if='splitDetailFlag' :splitDetailFlag='splitDetailFlag' :splitDetailData='splitDetailData' @closeSplitDetailDialogAndRefresh='closeSplitDetailDialogAndRefresh' @closeSplitDetailDialog='splitDetailFlag=false'></manualSplit>
	</div>
</template>

<script>
import manualSplit from '@/components/page/Controloverinvoices/manualSplit';
import { getdata } from '../../page/FullyElectronicInvoices/FillingPositiveInvoice/data.js';
var _this;
    export default {
		components: {manualSplit},
		data() {
			return {
				searchlist:[{
					prop: 'docNo',
					label: '单 据 号',
					type: 'input'
				},{
					prop: 'purchaserName',
					label: '购方名称',
					type: 'input'
				},{
					prop: 'zhidr',
					label: '制单人',
					type: 'input'
				},{
					prop: 'createTime',
					label: '创建日期',
					type: 'date',
					valueformat: 'yyyy-MM-dd'
				},{
					prop: 'fapzt',
					label: '单据状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '草稿',
							value: '-1'
						},
						{
							label: '待审核',
							value: '0'
						},
						{
							label: '已审核',
							value: '1'
						},
						{
							label: '开票中',
							value: '3'
						},
						{
							label: '开票失败',
							value: '7'
						}
					]
				},{
					prop: 'faply',
					label: '单据来源',type: 'select',
					selectval: [
							{
								label: '全部',
								value: ''
							},
							{
								label: '文件导入',
								value: '1'
							},
							{
								label: '手工录入',
								value: '2'
							},
							{
								label: '客户接口',
								value: '3'
							},
							{
								label: '税控同步',
								value: '4'
							},
							{
								label: '支付开票',
								value: '5'
							},
							{
								label: '扫码开票',
								value: '6'
							},
							{
								label: '红冲重开',
								value: '7'
							},
							{
								label: '作废重开',
								value: '8'
							}
						]},{
					prop: 'kaipzddm',
					label: '税盘编号',
					type: 'input'
				},{
					prop: 'hasList',
					label: '是否清单',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '是',
							value: '1'
						},
						{
							label: '否',
							value: '0'
						}
					]
				},{
					prop: 'shangpmc',
					label: '商品名称',
					type: 'input'
				},{
					prop: 'kehbh',
					label: '客户编号',
					type: 'input'
				},{
					prop: 'jiashj',
					label: '价税合计',
					type: 'input'
				},{
					prop: 'hejje',
					label: '金额合计',
					type: 'input'
				},{
					prop: 'hejse',
					label: '税额合计',
					type: 'input'
				},{
					prop: 'shuil',
					label: '税率',
					type: 'select',
					selectval: [
						{
							label: '13%',
							value: '0.13'
						},
						{
							label: '12%',
							value: '0.12'
						},
						{
							label: '11%',
							value: '0.11'
						},
						{
							label: '10%',
							value: '0.10'
						},
						{
							label: '9%',
							value: '0.09'
						},
						{
							label: '8%',
							value: '0.08'
						},
						{
							label: '7%',
							value: '0.07'
						},
						{
							label: '6%',
							value: '0.06'
						},
						{
							label: '5%',
							value: '0.05'
						},
						{
							label: '4%',
							value: '0.04'
						},
						{
							label: '3%',
							value: '0.03'
						},
						{
							label: '1.5%',
							value: '0.015'
						},
						{
							label: '1%',
							value: '0.01'
						},
						{
							label: '0%',
							value: '0.00'
						}
					]
				},{
					prop: 'shenqr',
					label: '申请人',
					type: 'input'
				},{
					prop: 'zidysm',
					label: '自定义说明',
					type: 'input'
				},],
				//重选
				Anewtk: false, //唤醒重选发票类型弹框
				fpzloptions: getdata().fpzloptions,
				fplxoptions: getdata().fplxoptions,
				tdywoptions: getdata().tdywoptions,
				cezsoptions: getdata().cezsoptions,
				jazsoptions: getdata().jazsoptions,
				fpzl: '',
				fplx: '',
				cxtdywxz: '',
				cxcezsxz: '',
				cxjazsxz: '',
				isjytdyw: false,
				isjycezs: false,
				isjyjazs: false,
			    //编辑数据
                enitList:{},
				checkmeauList: ['选型1', '选型2'],
				meaulist: ['选型1', '选型2', '选型3', '选型4', '选型5'],
				formLabelWidth: '150px',
				cxdialog: false,
				/* 开具弹框 */
				kgdialog: false,
				kgtitle: ['开具'],
				tableDatans: [{}],
				tableDatakp: [{}],
				page: 1,
				pagenum: 10,
				totalcount: 10,
				serchform: {},

				tableData: [{}, {}, {}, {}],
				headtitle: ['发票管理', '正数发票填开'],
				cxtitle: ['高级查询'],
				serchval: '',
				title: '',
				allitem: {},
				outerVisible: false,
				historyDialog: false,
				chooseitem: {}, //选中数据
				deletecommids: '', //选中的id
				selectCount: 0,
				jiastotalSum: 0,
				taxtotalSum: 0,
				selectRows: [],
				/* 高级查询搜索条件 */
				searchalllist: {
					docNo: '',
					docStartDate: '',
					docEndDate: '',
					excludeTaxAmount: '',
					includeTaxAmount: '',
					purchaserName: '',
					purchaserTaxNumber: '',
					reviewer: '',
					issuer: '',
					payee: '',
					billingStartdate: '',
					billingEnddate: '',
					fpalldate: '',
					Documentstatus_g: '',
					//搜索
					listlikeSearch: '',
					faplxdm: '',
					zhidr:'',
					zidysm: '',
					createTime:'',
          kaipzddm:''
				},
				listlikeSearch: '',
				selectKaipj: '',
				selectIds: [],
				kaijuType: '',
				tableHeight: '',
				currentpage: 1,
				elementui_page_component_key: '',
				isAudit: false,
				choosetitleindex: '',
				zhijieIds: '',
				kpdyin: false,
				buttomroute: {},
				buttonqx: {},
				bianglxs: [{
						label: '修改',
						value: '0'
					},
					{
						label: '拆分',
						value: '1'
					},
					{
						label: '合并',
						value: '2'
					},
					{
						label: '分组',
						value: '3'
					},
					{
						label: '开票',
						value: "4"
					},
					{
						label: '回滚',
						value: '5'
					}
				],
				historyConditionForm: {
					xiugr: '',
					bianglx: ''
				},
				historyData: [],
				selectRowDanjh: '',
				isshou: true,
        formlist: [
          {
            prop: "text",
            label: "修改自定义说明二",
            type: "textarea",
            isnotnull: true
          }
        ]
        ,formdata: {
          text: ""
        },
        dialogApproval:false,
        splitDetailFlag:false,
                splitDetailData:null,
                rowOpenInvoice:null,
        sort:"asc",
        order:"id"
			};
		},
		watch: {
			fpzl: function(indexVal, oldVal) {
				this.ChangeInMonitoring();
			},
			cxtdywxz: function(indexVal, oldVal) {
				this.ChangeInMonitoring();
			},
			cxcezsxz: function(indexVal, oldVal) {
				this.ChangeInMonitoring();
			},
			cxjazsxz: function(indexVal, oldVal) {
				this.ChangeInMonitoring();
			}
			},
		created() {
			_this = this;
			this.buttomroute = JSON.parse(localStorage.getItem("Fillinandissuepositiveinvoice"))
			//this.searchalllist.faplxdm = this.choosetitleindex;
			// 获取对象的名称数组 获取数组的第一个元素 判断 赋值类型
			var arr = Object.getOwnPropertyNames(this.buttomroute);
			var fplx = arr[0];
			if("Fillinandissuepositiveinvoice_ZP_select" ==fplx){
				this.searchalllist.faplxdm = "007";
				this.choosetitleindex = "007";
			}else if("Fillinandissuepositiveinvoice_DP_select" ==fplx){
				this.searchalllist.faplxdm = "026";
				this.choosetitleindex = "026"
			}else if("Fillinandissuepositiveinvoice_ZZ_select" ==fplx){
				this.searchalllist.faplxdm = "004";
				this.choosetitleindex = "004"
			}else if("Fillinandissuepositiveinvoice_DZ_select" ==fplx){
				this.searchalllist.faplxdm = "028";
				this.choosetitleindex = "028"
			}
			this.getDocList();
			this.getIsAudit();
            this.getbottomroute()
		},
		mounted() {
			this.tableHeight = this.diagheightzhengshutiankai();
			this.repairtable();
		},
		methods: {
			reelecttype(){
				if(this.fpzl==""){
					this.$message.error("请选择发票种类");
					return;
				}
				if(this.fplx==""){
					this.$message.error("请选择发票类型");
					return;
				}
				let params={};
				params.ids=this.chooseitem.map(v=>v.id);
				params.chaezs=this.cxcezsxz;
				params.faplxdm=this.fplx;
				params.fapzl=this.fpzl;
				params.jianazs=this.cxjazsxz;
				params.tedywlx=this.cxtdywxz;
				console.log(params)
				this.$https.fetchPost('/felec/positiveInvoice/docConversion', params).then(res => {
					if (res.data.code == '200') {
						this.$message.success("共改变"+res.data.data.totalNumber+"张发票，成功"+res.data.data.successNumber+"条，失败"+res.data.data.failNumber+"条");

					} else {
						this.$message.error(res.data.message);
					}
				this.Anewtk = false;
				 this.getDocList();
				});
			},
			Anew() {


				if (this.chooseitem.length<1) {
					this.$message.error('请选择需要修改类型的数据');
				} else {

					for(var i=0; i<this.chooseitem.length;i++){
							console.log(this.chooseitem[i].documentStatus)
						if(this.chooseitem[i].documentStatus!='-1'&&this.chooseitem[i].documentStatus!='0'&&this.chooseitem[i].documentStatus!='1'){
							this.$message.error("请选择单据状态为[草稿][待审核][已审核]的单据");
							return;
						}
					}
					this.fpzl= ''
					this.fplx= ''
					this.cxtdywxz= ''
					this.cxcezsxz= ''
					this.cxjazsxz= ''
					this.Anewtk = true;
				}

			},
			ChangeInMonitoring() {
				if (this.fpzl == '1') {
					this.isjytdyw = true;
					this.isjycezs = true;
					this.isjyjazs = true;
					this.cxtdywxz = '';
					this.cxcezsxz = '';
					this.cxjazsxz = '';
				} else {
					if (this.isjytdyw && this.isjycezs && this.isjyjazs) {
						this.isjytdyw = false;
						this.isjycezs = false;
						this.isjyjazs = false;
					}
				}
				if (this.cxtdywxz == '03') {
					this.isjyjazs = true;
					this.cxjazsxz = '';
				} else if (this.cxtdywxz == '06') {
					this.jazsoptions = [
						{
							value: '2',
							label: '住房租赁'
						}
					];
					if (this.cxjazsxz != '') {
						this.cxjazsxz = '2';
					}
				} else {
					this.jazsoptions = getdata().jazsoptions;
					if (this.fpzl != '1') {
						this.isjyjazs = false;
					}
				}
				if(this.cxcezsxz!=""){
					this.isjyjazs=true;
					this.cxjazsxz="";
				}else{
					if (this.fpzl != '1'&&this.cxtdywxz != '03') {
						this.isjyjazs = false;
					}
				}

				if(this.cxjazsxz!=""){
					this.isjycezs=true;
					this.cxcezsxz="";
				}else{
					if (this.fpzl != '1') {
						this.isjycezs = false;
					}
				}


			},
            closeSplitDetailDialogAndRefresh(){
                this.splitDetailFlag=false;
                this.getDocList();
            },
			repairtable() {
				this.$nextTick(() => {
					setTimeout(() => {
						this.$refs.multipleTable.doLayout();
					}, 300);
					window.onresize = () => {

						setTimeout(() => {
							this.$refs.multipleTable.doLayout();
						}, 300);
					};
				});
			},
			getbottomroute() {
				switch (this.choosetitleindex) {
					case "026":
						this.buttonqx = this.buttomroute.Fillinandissuepositiveinvoice_DP_select || {}
						break;
					case "028":
						this.buttonqx = this.buttomroute.Fillinandissuepositiveinvoice_DZ_select || {}
						break;
					case "007":
						this.buttonqx = this.buttomroute.Fillinandissuepositiveinvoice_ZP_select || {}
						break;
					case "004":
						this.buttonqx = this.buttomroute.Fillinandissuepositiveinvoice_ZZ_select || {}
						break;
				}
			},
			clickchoosetap() {
				this.currentpage = 1;
				this.elementui_page_component_key++;
				this.page = 1;
				this.searchalllist.faplxdm = this.choosetitleindex;
				this.getbottomroute()
				this.getDocList();
				this.getIsAudit();
			},
			forserchlist() {
				this.currentpage = 1;
				this.elementui_page_component_key++;
				this.page = 1;
				//Object.keys(this.searchalllist).map(key => (this.searchalllist[key] = ''));
				this.getDocList();
			},
			//重置
			resetForm(formName) {
				Object.keys(this.searchalllist).map(key => (this.searchalllist[key] = ''));
			},
			forshuai() {
				this.elementui_page_component_key++;
				this.currentpage = 1;
				if (this.searchalllist.alldate) {
					this.searchalllist.docStartDate = this.searchalllist.alldate[0];
					this.searchalllist.docEndDate = this.searchalllist.alldate[1];
				}
				if (this.searchalllist.fpalldate) {
					this.searchalllist.billingStartdate = this.searchalllist.fpalldate[0];
					this.searchalllist.billingEnddate = this.searchalllist.fpalldate[1];
				}
				delete this.searchalllist['alldate'];
				delete this.searchalllist['fpalldate'];
				this.getDocList();
			},
            //设置为待审核
            setingCheckPending(){
                if (this.selectCount < 1) {
                    this.$message({
                        type: 'error',
                        message: '请选择要置为待审核的发票'
                    });
                    return;
                }
                let filterList = this.chooseitem.filter(item => item.documentStatus!='3' && item.documentStatus != '7');
                if (filterList.length > 0) {
                    this.$message({
                        type: 'error',
                        message: '只能选择开票中或开票失败的发票'
                    });
                    return;
                }

                ///doc/cancelAudit
                this.$https.fetchPost('/doc/cancelAudit', this.selectIds).then(res => {
                    if (res.data.success) {
                        this.getDocList();
                    }
                });
            },
			/* 接口数据 */
			/* 获取开票管理表格区列表数据 */
			getDocList() {
				var newForm = JSON.parse(JSON.stringify(this.searchalllist));
				if (newForm.createTime) {
				    newForm.createTime = newForm.createTime.join(',');
				}
				let params = {
					likeSearch: this.listlikeSearch,
					page: this.page,
					limit: this.pagenum,
          sort: this.sort,
          order: this.order,
					search: newForm
				};
				this.$https.fetchPost('/invoice/issueInfo/getDocList', params).then(res => {
					this.cxdialog = false;
					this.totalcount = res.data.count;
					this.tableData = res.data.data;
					// this.tableData.forEach(item => {
					// 	item.newjiastotal = this.toThousands(item.totalall.jiastotal);
					// });
          for (let i=0;i<res.data.data.length;i++){
            res.data.data[i].index=(i+1);
            res.data.data[i].newjiastotal=this.toThousands(res.data.data[i].totalall.jiastotal);
          }
					this.repairtable();
				});
			},
			/* table选中发生改变 */
			handleSelectionChange(e) {
                console.log("1231312312321312321321321")
				this.chooseitem = [];
				this.selectIds = [];
				this.selectCount = 0;
				this.jiastotalSum = 0;
				this.taxtotalSum = 0;
				this.deletecommids = '';
				this.selectRows = [];
				e.forEach((item, index) => {
					this.chooseitem.push(item);
					this.selectIds.push(item.id);
					this.deletecommids = this.deletecommids + item.id + ',';
					this.selectCount++;
          this.jiastotalSum=this.printFn(parseFloat(this.jiastotalSum)+parseFloat(item.totalall.pricetotal==""?"0":item.totalall.pricetotal));
          this.taxtotalSum= this.printFn(parseFloat(this.taxtotalSum)+parseFloat(item.totalall.taxtotal==""?"0":item.totalall.taxtotal));
					this.selectRows.push(item);
				});
				var reg = /,$/gi;
				this.deletecommids = this.deletecommids.replace(reg, '');
				this.deletecommidslength = e.length;
			},
      selectClick(row, column, event){
        this.$refs.multipleTable.toggleRowSelection(row);
      },
      tableSortChange(column, prop, order){
        this.order=column.prop;
        if(column.order){
          this.sort=column.order.replace("ending","");
        }else{
          this.sort="desc";
          this.order="id";
        }
        this.getDocList();
      },
			/* 开票管理表格区--发票预览 */
			handleClick(row, title) {
				//console.log(row);
				this.title = title;
				this.allitem = JSON.parse(JSON.stringify(row));
                if ((this.allitem.priceall == null || this.allitem.priceall.length == 0) && this.allitem.listoflists.length > 0 ) {
                    this.allitem.priceall = [{type:4}];
                }
				if(this.allitem.stateall.istaxincluded){
					this.allitem.priceall.forEach(r=>{
             // r.chooseMoney = r.chooseMoney -r.taxRatemoney;
                // 加一个非空判断，以免空单价出问题
                if(r.unitPrice) {
       //           if (r.quantity && r.quantity > 1) {
      //              r.unitPrice = (r.unitPrice - (r.taxRatemoney / r.quantity)).toFixed(2);
     //             } else {
     //               r.unitPrice = r.unitPrice - r.taxRatemoney;
    //              }
                   if(r.quantity && !isNaN(r.taxRate)){
                    r.unitPrice = ((r.chooseMoney / (parseFloat(r.taxRate)  + 1) )/ r.quantity).toFixed(15);
                   }
                  // let charLength = String(r.unitPrice).substring(String(r.unitPrice).lastIndexOf(".")+1).length;
                   //if(charLength>15){
                     //  r.unitPrice = parseFloat(r.unitPrice).toFixed(15);
                     //  let charSuffix = String(r.unitPrice).substring(String(r.unitPrice).lastIndexOf(".")+1);
                     //  if(charSuffix == '000000000000000'){
                    //         r.unitPrice = parseFloat(r.unitPrice).toFixed(2);
                   //    }
                  // }
                }
                   r.chooseMoney = r.chooseMoney -r.taxRatemoney;
                   r.chooseMoney = parseFloat(r.chooseMoney).toFixed(2);
					})
				}
				this.outerVisible = true;
				// 记号记号
			},

			/* 发票返回信息 */
			InvoiceBackInformation(e) {
				let params = {
					docData: JSON.stringify(e)
				};
				this.$https.fetchPost('/invoice/issueInfo/saveAppDoc', params).then(res => {
					if (res.data.success) {
						//	如果单据状态为“草稿”状态，则不允许“自动审核”、“开具”、“开具并打印”等功能
						let documentStatus = res.data.obj.data.documentStatus;	//单据状态

						if (e.type != "kaiju" & e.type != "kaijubingdayin") {
                            this.Manualinput()
							// this.$confirm(res.data.message, {
							// 	confirmButtonText: '确定',
                            //     cancelButtonText: '继续',
							// 	callback: action => {
							// 	    if (action === 'cancel'){
                            //             this.Manualinput()
                            //         }
                            //     }
							// });
						}
						this.getDocList();
						this.outerVisible = false;
						this.zhijieIds = res.data.obj.id;
						if(e.type != "kaiju" & e.type != "kaijubingdayin") {	//	保存操作
							if(documentStatus != -1) {
								if (this.isAudit) {
									var auditIds = [];
									auditIds.push(res.data.obj.id);
									this.$https.fetchPost('/doc/audit', auditIds).then(res => {
										if (res.data.success) {
											this.getDocList();
											this.$message.success(res.data.message);
										} else {
											this.$message.error(res.data.message);
										}
									});
								}
							}
						} else {	//	开具、开具并打印操作
							if(documentStatus != -1) {
								//	审核
								var auditIds = [];
								auditIds.push(res.data.obj.id);
								this.$https.fetchPost('/doc/audit', auditIds).then(res => {
									if (res.data.success) {
										// this.getDocList();
										this.$message.success(res.data.message);
									} else {
										this.$message.error(res.data.message);
									}
								});

								//	非“草稿”状态才能“开具”、“开具并打印”
								if (e.type == "kaiju") {
									this.openInvoiceSingle(res.data.obj.data, "", res.data.obj.id)
								}
								if (e.type == "kaijubingdayin") {
									this.openInvoiceSingle(res.data.obj.data, "dayi")
								}
							} else {
								if(res.data.warningMessage) {
									this.$message.error(res.data.warningMessage.substring(0, res.data.warningMessage.length - 1));
								}
								_this.outerVisible = true;
								//	草稿状态：票面信息校验不完整，提示错误信息，且不走审核以及开具等流程
								//	删除生成的草稿单据
								this.zhijieIds = "";
								this.delDoc(res.data.obj.id);
							}
						}
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			shenhechoose(e) {
				if (e) {
					/*try {
					        this.selectRows.forEach(item => {
					            debugger
					            if ("1" !== item.documentStatus && "7" !== item.documentStatus) {
					                throw new Error("单据号为" + item.stateall.docNo + "的发票不为已审核或开具失败的发票，不能进行开具操作");
					            }
					        });
					    } catch (err) {
					        this.$message.error(err.message);
					        return;
					    }*/
					let updateInvoiceStatusParams = {
						docId: this.selectRows[0].id
					};
					this.$https
						.fetchPost('/doc/updateInvoiceStatus', updateInvoiceStatusParams)
						.then(
							res => {
								let params = {
									docId: this.selectRows[0].id,
									kaipzddm: this.selectKaipj
								};
								this.$https.fetchPost('/httpapi/kpsj/auditAndOpenInvoice', params).then(res => {
									if (res.data.success) {
										this.kgdialog = false;
										this.getDocList();
										this.outerVisible = false;
										this.$alert('开具成功', '开具结果', {
											confirmButtonText: '确定'
										});
									}
								});
							},
							err => {}
						)
						.catch(error => {
							this.$https.fetchPost('/httpapi/kpsj/auditAndOpenInvoice', params).then(res => {
								if (res.data.success) {
									this.kgdialog = false;
									this.getDocList();
									this.outerVisible = false;
								}
							});
						});
				}
			},
			/* 关闭开票弹框 */
			closeouterVisible() {
				this.outerVisible = false;
			},
			/* 单据录入 */
			Manualinput() {
				this.kaijuType = 'normal';
				this.title = '手工录入';
				this.allitem = {
					ruleFormbxiao: '',
					stateall: {
						choosetitleindex: this.choosetitleindex,
						istaxincluded: false,
						isqingdan: false,
						taxpattern: '0'
					}
				};
				let params = {
					faplx: ''
				};
				this.$https.fetchPost('/invoice/issueInfo/getCurRuleFormbxiao', params).then(res => {
					if (res.data.success) {
						let ruleFormbxiaoInit = JSON.parse(JSON.stringify(res.data.obj[0]));
						_this.allitem.ruleFormbxiao = ruleFormbxiaoInit;
						console.info(_this.allitem);
						_this.outerVisible = true;
					} else {
						_this.$message.error(res.data.message);
					}
				});
			},
			/* 单据删除 */
			Docdelete() {
				if (this.deletecommids == '') {
					this.$message({
						type: 'error',
						message: '请选择要删除的发票'
					});
					return false;
				}
				let status = true;
				for (var i = 0; i < this.chooseitem.length; i++) {
					if (this.chooseitem[i].documentStatus != '-1' && this.chooseitem[i].documentStatus != '0') {
						this.$message({
							type: 'error',
							message: '当前单据状态无法删除'
						});
						status = false;
						break;
					}
				}
				if (status) {
					this.$confirm('此操作将删除该单据, 是否继续?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						})
						.then(() => {
							this.delDoc(this.deletecommids);
						})
						.catch(() => {});
				}
			},
			/* 开票管理表格区--发票预览编辑 */
			handleEdit(row, title) {
			    this.enitList=row;
				this.kaijuType = 'normal';
				this.title = title;
				let fapData = JSON.parse(JSON.stringify(row));
				// fapData.totalall.forEach((item,index)=>{
				//     item.quantity=-item.quantity;
				// });
				this.allitem = fapData;
                if ((this.allitem.priceall == null || this.allitem.priceall.length == 0) && this.allitem.listoflists.length > 0 ) {
                    this.allitem.priceall = [{type:4}];
                }
                if(this.allitem.stateall.istaxincluded){
                    this.allitem.priceall.forEach(r=>{
                        // 加一个非空判断，以免空单价出问题
                        if(r.unitPrice) {

                            if(r.quantity && !isNaN(r.taxRate)){
                                r.unitPrice = ((r.chooseMoney / (parseFloat(r.taxRate)  + 1) )/ r.quantity).toFixed(15);
                            }

                        }
                        r.chooseMoney = r.chooseMoney -r.taxRatemoney;
                        r.chooseMoney = parseFloat(r.chooseMoney).toFixed(2);
                    })
                }
                console.log(fapData);
				this.outerVisible = true;
			},
			showHistory(row) {
				let params = {
					danjh: row.stateall.docNo,
				};
				this.$https.fetchPost('/invoice/issueInfo/getHistoryChange', JSON.stringify(params)).then(res => {
					this.historyData = res.data.obj;
				});
				this.historyDialog = true;
				this.selectRowDanjh = row.stateall.docNo;
			},
			queryHistory() {
				let params = JSON.parse(JSON.stringify(this.historyConditionForm));
				params['danjh'] = this.selectRowDanjh;
				this.$https.fetchPost('/invoice/issueInfo/getHistoryChange', JSON.stringify(params)).then(res => {
					this.historyData = res.data.obj;
				})

			},
			rollbackOperation(row) {
				let pich = row.pich;
				this.$https.fetchPost('/invoice/issueInfo/rollbackOperation', pich).then(res => {
					if (res.data.success) {
						this.queryHistory();
					}
				})
			},
			closeAndQuery() {
				this.getDocList();
				this.historyDialog = false;
			},
			/* 子传父 */
			closekgdialog(e) {
				this.kgdialog = e;
			},
			/* 筛选 */
			forserchshai() {
				this.cxdialog = false;
			},
			forcloseshai() {
				this.cxdialog = false;
			},
			/* 重置 */
			forrestsgai() {
				Object.keys(this.serchform).map(key => (this.serchform[key] = ''));
			},
			handleSizeChange(val) {
				this.pagenum = val;
				this.getDocList();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getDocList();
			},

			/* 开具弹框 */
			forkaiju(kaijuType,isjpdyin) {
                this.rowOpenInvoice = null;
				this.kpdyin = isjpdyin
				this.kaijuType = kaijuType;
				if (this.selectCount < 1) {
					this.$message({
						type: 'error',
						message: this.$tolertJSON['005-1']
					});
					return;
				}
				this.$https.fetchPost('/doc/getKaipjList').then(res => {
					console.log(JSON.parse(res.data.obj));
					this.tableDatakp = JSON.parse(res.data.obj);
					this.kgdialog = true;
				});
			},
			openInvoiceSingle(row, kpdyin, id) {
                this.selectRows = [row];
        var auditIds = [];
        auditIds.push(id);
/*        this.$https.fetchPost('/doc/audit', auditIds).then(resObj => {
          if (resObj.data.success) {*/
            this.getDocList();
            row.documentStatus = "1";
            if ("dayi" === kpdyin) {
              this.kpdyin = true
            } else {
              this.kpdyin = false
            }
            this.kaijuType='normal';
            if (this.$refs.multipleTable) {
              this.$refs.multipleTable.clearSelection();
            }
            // this.selectIds = [];
            // this.selectRows = [];
            // this.selectRows.push(row);
                this.rowOpenInvoice = row;
            this.selectIds = [row.id];
            this.$https.fetchPost('/doc/getKaipjList').then(res => {
              this.tableDatakp = JSON.parse(res.data.obj);
              this.kgdialog = true;
            });
       /*   }
        });*/
			},
			openInvoice() {
                if (this.selectRows.length == 0 && this.rowOpenInvoice != null) {
                    this.selectRows.push(this.rowOpenInvoice);
                }
				if (this.selectKaipj === '') {
					this.$message({
						type: 'error',
						message: this.$tolertJSON['005-2']
					});
					return;
				}
        if (this.selectKaipj === '') {
          this.$message({
            type: 'error',
            message: this.$tolertJSON['005-2']
          });
          return;
        }
				try {
					this.selectRows.forEach(item => {
						if ('1' !== item.documentStatus && '7' !== item.documentStatus) {
							throw new Error('单据号为' + item.stateall.docNo + '的发票不为已审核或开具失败的发票，不能进行开具操作');
						}
					});
				} catch (err) {
					this.$message.error(err.message);
					return;
				}
				var faplxdm = this.selectRows[0].stateall.choosetitleindex;
				try {
					this.selectRows.forEach(item => {
						if (faplxdm !== item.stateall.choosetitleindex) {
							throw new Error('只能对相同类型发票进行开具操作！');
						}
					});
				} catch (err) {
					this.$message.error(err.message);
					return;
				}
				var success = false;
				this.getOpenInvoiceMessage(faplxdm, this.selectRows.length, success);
                this.rowOpenInvoice = null;
			},
			doOpenInvoiceDialog(message) {
				this.$confirm(message, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						switch (this.kaijuType) {
							case 'normal':
								this.noamrlOpenInvoice();
								break;
							case 'appAudit':
								this.appAuditOpenInvoice();
								break;
						}
					})
					.catch(() => {});
			},
			noamrlOpenInvoice() {
				try {
					this.selectRows.forEach(item => {
						if ('1' !== item.documentStatus && '7' !== item.documentStatus) {
							throw new Error('单据号为' + item.stateall.docNo + '的发票不为已审核或开具失败的发票，不能进行开具操作');
						}
					});
				} catch (err) {
					this.$message.error(err.message);
					return;
				}
				let updateInvoiceStatusParams = {
					ids: this.selectIds
				};
				this.$https
					.fetchPost('/doc/updateInvoiceStatus', updateInvoiceStatusParams)
					.then(res => {
					  // 此时查询界面可能导致开票中
            // this.getDocList();
						this.doOpenInvoice();

					})
			},
			doOpenInvoice(loading) {
        var loading = this.$loading({
          lock: true,
          text: 'loading……',
          background: 'rgba(0, 0, 0, 0.7)'
		});
		// 修改发票的提交顺序
				var indexs=[];
				var idsSort = [] ;
				//console.log(this.selectIds);
        if(this.selectIds.length>1){
          for(var j=0;j<this.selectIds.length ;j++){
            var id = this.selectIds[j];
            for(var i = 0 ; i<this.tableData.length;i++){
              var tableid = this.tableData[i].id;
              if(id ==tableid){
                indexs.push(i);
              }
            }
          }
          var indexSort = indexs.sort() ;
          for(var k= 0 ;k<indexSort.length;k++){
            idsSort.push( this.tableData[indexSort[k]].id);
          }
        }else if(this.selectIds.length==1){
          idsSort.push(this.selectIds[0]);
        }else{
          this.$message({
            type: 'error',
            message: "单据异常，请联系运维人员"
          });
          return;
        }

				//console.log(idsSort);
				let params = {
					ids: idsSort,
					kaipzddm: this.selectKaipj
				};
				this.$https.fetchPost('/doc/openInvoice', params).then(res => {
					if (res.data.success) {
					  loading.close();
						this.kgdialog = false;
						this.$alert(res.data.message, '开具结果', {
							confirmButtonText: '确定'
						});
						if (this.kpdyin) {
							this.printPost(res.data.obj);
						}
						this.getDocList();
					} else {
						this.kgdialog = false;
						this.getDocList();
                        this.$message({
                            type: 'error',
                            message: res.data.message,
                            duration: 10

                        });
					}
				});
			},
			appAuditOpenInvoice() {
				this.selectRows[0].stateall.shenhetype = true;
				this.handleEdit(this.selectRows[0], '预览发票');
			},
			/* 高级查询弹框	 */
			forserch() {
				this.cxdialog = true;
			},
			/* 单据删除	 */
			delDoc(delids) {
				let params = {
					ids: delids
				};

				this.$https.fetchPost('/invoice/issueInfo/delDoc', params).then(res => {
					if (res.data.success) {
						this.deletecommids = '';
						this.deletecommidslength = 0;
                        this.page = 1;
                        this.currentpage = 1;
                        console.log(this.page);
						this.getDocList();
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			radiochange(val) {
                console.log(this.selectIds);
				this.selectKaipj = val.kaipjbh;
			},
			audit() {
				if (this.selectCount < 1) {
					this.$message({
						type: 'error',
						message: this.$tolertJSON['005-3']
					});
					return;
				}
				this.$https.fetchPost('/doc/audit', this.selectIds).then(res => {
					if (res.data.success) {
						this.kgdialog = false;
						this.$alert(res.data.message, '审核结果', {
							confirmButtonText: '确定'
						});
						this.getDocList();
					} else {
						this.$message({
							type: 'error',
							message: res.data.message
						});
					}
				});
			},
			cancelAudit() {
				try {
					this.selectRows.forEach(item => {
						if ('1' !== item.documentStatus) {
							throw new Error('单据号为' + item.stateall.docNo + '的发票不为已审核的发票，不能进行操作');
						}
					});
				} catch (err) {
					this.$message.error(err.message);
					return;
				}
				if (this.selectRows[0].documentStatus !== '1') {
					this.$message({
						type: 'error',
						message: this.$tolertJSON['005-7']
					});
					return;
				}
				this.$https.fetchPost('/doc/cancelAudit', this.selectIds).then(res => {
					if (res.data.success) {
						this.getDocList();
					}
				});
			},
			auitAndKaiju() {
				if (this.selectCount < 1) {
					this.$message({
						type: 'error',
						message: '请选择需要审核并开具的发票。'
					});
					return;
				}
				if (this.selectCount !== 1) {
					this.$message({
						type: 'error',
						message: this.$tolertJSON['005-4']
					});
					return;
				}
				if (this.selectRows[0].documentStatus !== '-1' && this.selectRows[0].documentStatus !== '0') {
					this.$message({
						type: 'error',
						message: this.$tolertJSON['005-5']
					});
					return;
				}
				this.forkaiju('appAudit');
			},
			updateIsAudit() {
				let isAudit = "0";
				if (this.isAudit) {
					isAudit = "1";
				}
				let params = {
					faplxdm: this.choosetitleindex,
					isAudit: isAudit
				};
				this.$https.fetchPost('/doc/updateIsAutomaticAudit', params).then(res => {});
			},
			getIsAudit() {
				this.$https.fetchPost('/doc/getIsAutomaticAudit', this.choosetitleindex).then(res => {
					if (res.data.obj === "1") {
						this.isAudit = true;
					} else {
						this.isAudit = false;
					}
				});
			},
			mergeSameCustomer() {
				// if (this.selectCount < 2) {
				// 	this.$message({
				// 		type: 'info',
				// 		message: '至少选择两张单据'
				// 	});
				// 	return;
				// }
				this.$https.fetchPost("/doc/mergeSameCustomer", this.selectIds).then(res => {
					if (res.data.success) {
						this.getDocList();
					}
				})
			},

            detailSplit(){
                if (this.selectCount > 1) {
                    this.$message({
                        type: 'error',
                        message: '只能选择一条数据！'
                    });
                    return;
                }
                if (this.selectCount == 0) {
                    this.$message({
                        type: 'error',
                        message: '至少选择一张单据'
                    });
                    return;
                }
                if (this.selectRows[0].documentStatus != '0') {
                    this.$message({
                        type: 'error',
                        message: '只有待审核的发票才能进行手工拆分！'
                    });
                    return;
                }
                this.splitDetailData = this.selectRows[0];
                this.splitDetailFlag = true;
            },
			resetHistoryQueryForm() {
				Object.keys(this.historyConditionForm).map(key => (this.historyConditionForm[key] = ''));
			},
			printPost(ids) {
				let params = {
					ids: ids.join(','),
					printDetail: false
				};
				this.$https
					.fetchPost('/outputinv/opinvmb/printInvoiceMb', JSON.stringify(params))
					.then(
						res => {
							let data = res.data.data;
							this.printPaperInvWs(res.wsurl, data, params);
						},
						err => {
							console.info(err);
						}
					)
					.catch(err => {
						console.info(err);
					});
			},
			printPaperInvWs(wsurl, invoiceData, params) {
				wsurl = 'ws://127.0.0.1:50926/SysSvr'; // TODO 如果要改蒙柏客户端端口配置就去掉这行
				let ws = new WebSocket(wsurl);
				console.info('ws connect');
				console.info(JSON.stringify(invoiceData));
				console.info(JSON.stringify(params));
				ws.onopen = function() {
					console.info('ws.onopen');
					let invoice = {
						cmd: 'sendcmd',
						moduledll: 'InvoiceSvrDll.dll',
						senddata: invoiceData
					};
					console.info(invoice);
					ws.send(JSON.stringify(invoice));
				};
				let globalthis = this;
				ws.onmessage = function(evt) {
					console.info('ws.onmessage');
					let data = JSON.parse(evt.data);
					console.log('ws message' + data);
					if (data.code == 0 && (data.cmd == 'print' || data.cmd == 'printDirectly')) {
						globalthis.$https
							.fetchPost('/real/updatePaperInvoiceStatus', JSON.stringify(params))
							.then(res => {
								console.info('更新打印状态结果 : ' + JSON.stringify(res.data));
								if (res.data.success) {
									this.getInvoiceQueryList();
								}
							})
							.catch(err => {
								console.error(err);
							});
					}
				};
			},
			getOpenInvoiceMessage(faplxdm, fs) {
				var message = "当前发票代码：fapdm，发票号码:faphm，";
				if (fs > 1) {
					message += "开票份数：" + fs + "份，";
				}
				message += "库存kuc份，是否继续开票？";
        let jsonstr = {
          faplxdm : faplxdm,
          kaipzddm : this.selectKaipj
        }
        faplxdm = JSON.stringify(jsonstr);
				this.$https.fetchPost('/doc/getCurrentInvoiceInfo', faplxdm).then(res => {
					if (res.data.success) {
						var obj = res.data.obj;
						message = message.replace("fapdm", obj.fapdm);
						if (fs > 1) {
							var endfaphm = parseInt(obj.faphm) + parseInt(fs) - 1;
							message = message.replace("faphm", obj.faphm + "-" + endfaphm);
						} else {
							message = message.replace("faphm", obj.faphm);
						}
						message = message.replace("kuc", obj.kuc);
						this.doOpenInvoiceDialog(message);
					}
				});
			},
			changeshou() {
				this.isshou = !this.isshou
			},
      submitFrom(){
			  var param = {};
        param.ids=this.selectIds;
        param.text=this.formdata.text;

        this.$https.fetchPost('/doc/updateZidysm2', param).then(res => {
          if (res.data.success) {
            this.dialogApproval=false;
            this.getDocList();
          }
        });
      },
      //修改自定义说明二
      openUpdateZidysm2(){
        if (this.selectCount < 1) {
          this.$message({
            type: 'error',
            message: "请选择需要修改自定义说明的单据。"
          });
          return;
        }
        this.dialogApproval=true;
        if(this.$refs.taxform){
          this.$nextTick(() => {
            this.$refs.taxform.clearValidate();
          })
        }
      },
		}
	};
</script>

<style scoped="scoped" lang="less">
	.alltopform>div {
		margin-left: 60px;
	}

	/deep/ .el-table__fixed-body-wrapper {
		// top: 40px !important;
	}

	/deep/ .el-input--suffix .el-input__inner {
		padding-right: 15px;
	}

	/deep/ .el-dialog__body {
		padding: 0px 20px;
	}

	/deep/ .el-table--small td {
		padding: 4px 0;
	}

	/deep/ .el-table__body-wrapper {
		min-height: 160px;
	}

	.noneheader /deep/ .el-dialog__header {
		display: none;
	}

	.areatable {
		margin-top: 27px;
	}

	.aftericon:extend(.Centerhorizontally) {
		width: 36px;
		height: 33px;
		background: #ffffff;
		box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.09);
		opacity: 1;
		border-radius: 3px;
		margin-left: 20px;
	}

	.aftericon>img {
		width: 16px;
		height: 16px;
	}
.LeftAndRightLayout {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
}
	.areacontent {
		margin-top: -10px;
		margin-left: 21px;
	}

	.minheight {
		height: 50px;
		overflow: hidden;
    transition: all .3s ease;
	}

	.maxheight {
		max-height: 500px;
    overflow: hidden;
    transition: all .3s ease;
	}

  .shousuo:extend(.Verticalcenter) {
    height: 20px;
    margin-bottom: 10px;
    background-color: #f8f8f8;
  }
  .shousuo:hover {
    background: #f8f8f8;
  }
</style>
